<template>
  <div :style="{ paddingTop: isTest ? '26px' : '0' }">
    <div
      v-if="isTest"
      style="
        background-color: red;
        width: 100%;
        position: fixed;
        height: 26px;
        top: 0;
        left: 0;
      "
    >
      <div style="text-align: center; padding-block: 5px">
        Вы попали в тестовую версию 👀.
        <a
          href="https://tms.golden-bridge.kz"
          style="text-decoration: underline"
          >Перейти на рабочую версию</a
        >
      </div>
    </div>
    <div class="loading" v-if="$store.state.isLoading">
      <div class="loading-mask"></div>
      <div class="loading-content" role="status">
        <a-spin class="loading-icon" size="large" />
      </div>
    </div>
    <!--  -->
    <!-- <router-view /> -->
    <a-config-provider :locale="locale">
      <router-view />
    </a-config-provider>
  </div>
</template>
<script>
import enUS from "ant-design-vue/es/locale/en_US";
import kkKZ from "ant-design-vue/es/locale/kk_KZ";
import ru_RU from "ant-design-vue/es/locale/ru_RU";
import dayjs from "dayjs";
import "dayjs/locale/ru";
import "dayjs/locale/kk";
import { mapMutations } from "vuex";
export default {
  components: {},
  data() {
    return {
      isLoading: false,
      isTest: !window.location.href.includes("tms.golden-bridge"),
    };
  },
  computed: {
    locale() {
      switch (this.$i18n.locale) {
        case "en":
          return enUS;
        case "kz":
          return kkKZ;
        case "rus":
          return ru_RU;
        default:
          return ru_RU;
      }
    },
  },
  watch: {
    "$i18n.locale": {
      handler(val) {
        const dayjsLocales = {
          en: "en",
          kz: "kk",
          rus: "ru",
        };
        dayjs.locale(dayjsLocales[val] || "ru");
      },
      immediate: true,
    },
  },

  mounted() {
    this.watchChangeSize();
    window.onresize = () => {
      this.watchChangeSize();
    };
  },
  methods: {
    ...mapMutations({
      setBigWinType: "setBigWinType",
    }),
    watchChangeSize() {
      let offsetWid = document.documentElement.clientWidth;
      if (offsetWid >= 1000 && this.$store.state.isBigWin == false) {
        this.setBigWinType(true);
      } else if (offsetWid < 900 && this.$store.state.isBigWin == true) {
        this.setBigWinType(false);
      }
      offsetWid = null;
    },
  },
};
</script>
<style lang="scss">
* {
  outline: none;
}
.home {
  font-size: 12px;
}
.loading {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 999999;

  .loading-mask {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1;
    // background-color: #fff;
    // opacity: 0.1;
  }

  .loading-content {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 2;
    display: flex;

    .loading-icon {
      margin: auto;
    }
  }
}

a-modal {
  max-width: 300px;
}
</style>
